import { FC } from 'react';
import classNames from 'classnames';

import styles from './CheckBox.module.scss';

interface IRadioFilterSelectProps {
  style?: object;
  className?: string;
  id: string;
  name?: string | any;
  tips?: any;
  reg?: any;
  onChange?: any;
  checked?: any;
  disable?: boolean;
}

const CheckBox: FC<IRadioFilterSelectProps> = ({ id, className, name, tips, reg, disable, checked, onChange, style }) => {
  return (
    <div style={style} className={classNames(styles.CheckBox, disable && styles.disable, className)}>
      <input type="checkbox" {...reg} defaultChecked={checked} onChange={onChange} id={id} name={name} />
      <label htmlFor={id} className={checked ? styles.active : undefined}>
        {name}
      </label>
      {tips && (
        <a onClick={tips}>
          <span>?</span>
          &nbsp;
        </a>
      )}
    </div>
  );
};

export default CheckBox;
